<template>
  <div style="height: inherit">
    <filters
      :is-loaded="dataTableIsLoaded"
      @fetch-data="fetchData"
      :don-vis="donVis"
    />
    <data-table
      :is-loaded="dataTableIsLoaded"
      :data-table="dataTable"
      :total-list="totalList"
      :data-meta="dataMeta"
      @update-pagination="pagination"
      @update-perpage="perpage"
      @update-searchquery="searchquery"
    />
  </div>
</template>

<script>
/* eslint-disable */
import LayoutData from "@/layouts/LayoutData";
import { ref, computed, watch } from "@vue/composition-api";
import store from "@/store";
import { useRouter } from "@core/utils/utils";

import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import {} from "@/services/api/HoSoCanBoCongChuc/CanBoCongChucService";

import Filters from "./components/Filters.vue";
import DataTable from "./components/DataTable.vue";

import useSetup from "./useSetup";

export default {
  components: {
    Filters,
    DataTable,
  },
  data() {
    return {
      isWait: false,
    };
  },

  setup(props, { emit }) {
    const toast = useToast();
    const { route, router } = useRouter();
    const headerData = ref(LayoutData.header.data);
    const appInfo = ref();
    headerData.value.title = "Tra cứu thông tin";
    document.title =
      headerData.value.title + " | " + LayoutData.appInfo.data.appName;

    const dataTableIsLoaded = ref(false);
    const totalList = ref(0);
    const loadFilter = ref(null);
    const dataMeta = ref({});

    const {
      getDataList,
      getDonVi,
      refUserListTable,
      perPage,
      currentPage,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
    } = useSetup();
    const donVis = ref([]);

    getDonVi({}, (data) => {
      donVis.value = data;
    });

    const dataTable = ref([]);

    const fetchData = (filters) => {
      // console.log("filters", filters);
      dataTableIsLoaded.value = true;
      loadFilter.value = filters ? filters : loadFilter.value;

      loadFilter.value.start = currentPage.value;
      loadFilter.value.limit = perPage.value;
      loadFilter.value.content = searchQuery.value;
      // console.log(loadFilter.value);
      // let condition = {
      //   start: currentPage.value,
      //   limit: perPage.value,
      //   content: searchQuery.value,
      //   filter: loadFilter.value,
      // };
      getDataList(loadFilter.value, (data) => {
        dataTableIsLoaded.value = false;
        dataTable.value = data.data || dataTable.value;
        totalList.value = data.totalRows || 0;
        dataMeta.value = {
          from:
            perPage.value * (currentPage.value - 1) +
            (dataTable.value.length ? 1 : 0),
          to: perPage.value * (currentPage.value - 1) + dataTable.value.length,
        };
        // console.log("dataMeta", dataTable.value.length);
      });
    };

    const pagination = (value) => {
      currentPage.value = value;
    };

    const perpage = (value) => {
      perPage.value = value;
    };
    const searchquery = (value) => {
      searchQuery.value = value;
    };

    watch([currentPage, perPage, searchQuery], () => {
      // console.log("watch");
      fetchData();
    });

    return {
      donVis,
      pagination,
      perpage,
      searchquery,
      dataMeta,
      refUserListTable,
      fetchData,
      perPage,
      totalList,
      currentPage,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,

      dataTable,
      dataTableIsLoaded,
    };
  },
};
</script>

<style lang="scss" scoped></style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
